const PropTypes = require('prop-types');
// @vendor
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const moment = require('moment');
const { withRouter, Prompt } = require('react-router-dom');
// @helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { formatAmount } = require('utilities/currencyHelper');
// @commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const StockExchangeIndexVariation = require('components/broker/commons/stockExchange/stockExchangeIndexVariation');
const { EmptyState } = require('commonsComponents/emptyState');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
// @components
const BrokerMainStocksResultsListContentFilters = require('components/broker/brokerMainStocksResultsListContent/brokerMainStocksResultListContentFilters/brokerMainStocksResultListContentFilters');
const { BrokerClientWarningModal } = require('components/broker/commons/brokerClientWarningModal/brokerClientWarningModal');
// @constants
const { BROKER_INDEX_CATEGORY_SYMBOL } = require('constants/index');
// @actions
const BrokerClientWarningModalAction = require('actions/brokerClientWarningModal');
// @ helpers
const DateHelper = require('utilities/dateHelper');

const {
    BROKER_TODAYS_MAIN_STOCKS_MAX_COLUMN_WIDTH,
    MYPROFILE_BROKER_ERROR_URL,
    DATE_FORMAT_SLASHES_SHORT_DAY_MONTH_YEAR,
    DATE_FORMAT_DAY_MONTH_SHORT,
    MYPROFILE_BROKER_EXPLORE_STOCKS_URL,
    BROKER_TYPE_STOCKS_NEW_DECIMALS
} = require('constants/index');

const INITIAL_FILTERS = {
    term: {
        value: '',
        isActive: false
    }
}

class BrokerMainStocksResultsListContent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            nextLocation: null,
            filters: INITIAL_FILTERS,
            isBlockingRouteChange: false,
        };

        this.clearFilters = this.clearFilters.bind(this);
        this.activateTermFilter = this.activateTermFilter.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleBuy = this.handleBuy.bind(this);
    }

    activateTermFilter(value) {
        this.setState({
            filters: {
                term: {
                    value: value,
                    isActive: true
                }
            }
        });
    }

    buildEmptyState() {
        const primaryText = formatText('broker-todaysMainStocksEmptyState');
        const secondaryText = formatText('broker-todaysMainStocksEmptyStateSecondary')
        const linkText = formatText('broker-mainStocksGoToSearch')
        return (
            <EmptyState
                secondaryText={secondaryText}
                primaryText={primaryText}
                linkText={linkText}
                linkURL={MYPROFILE_BROKER_EXPLORE_STOCKS_URL}
                iconType="nointernet-wealth" />
        );
    }

    clearFilters() {
        this.setState({
            filters: INITIAL_FILTERS
        });
    }

    handleBuy(nextLink) {
        const { immbrokerClientWarningModal, showClientWarningModal, history } = this.props;
        const clientPersonalInfoUpdated = immbrokerClientWarningModal.get('clientPersonalInfoUpdated');
        const isFetching = immbrokerClientWarningModal.get('isFetching');
        const isFetched = immbrokerClientWarningModal.get('isFetched');

        if (isFetched && !isFetching) {
            if (!clientPersonalInfoUpdated) {
                showClientWarningModal(history);
                this.setState({
                    nextLocation: nextLink,
                    isBlockingRouteChange: true
                });
            } else {
                history.push(nextLink);
            }
        } else if (!isFetched && !isFetching) {
            history.push(MYPROFILE_BROKER_ERROR_URL);
        }
        window.modalInstance = this;
    }

    render() {
        const { title, immStocks, hasFilters, immBrokerExchangeIndexes } = this.props;
        const { filters } = this.state;
        const activeFilters = Object.getOwnPropertyNames(filters).find(
            filterName => filters[filterName].isActive
        );
        const indexStock = immStocks.find(product => {
            return product.get('category') === BROKER_INDEX_CATEGORY_SYMBOL;
        });
        const indexPosition = immStocks.indexOf(indexStock);

        let immStocksFinal;

        if (indexPosition !== -1) {
            immStocksFinal = immStocks.delete(indexPosition);
        } else {
            immStocksFinal = immStocks;
        }

        if (activeFilters) {
            const targetValue = filters.term.value.toLowerCase();
            immStocksFinal = immStocksFinal.filter(entry => {
                const matchName = entry.get('instrument').toLowerCase().indexOf(targetValue) !== -1;
                const matchIsin = entry.get('instrumentId').toLowerCase().indexOf(targetValue) !== -1;
                const matchTicker = entry.get('spcSymbol').toLowerCase().indexOf(targetValue) !== -1;

                return matchName || matchIsin || matchTicker;
            });
        }

        const tableRows = immStocksFinal.map((entry, index) => {
            const url = `/myprofile/broker/stocksBuy/${entry.get('instrumentId')}/${entry.get('miccode')}`;

            const updateDate = moment(entry.get('tradeDate'), DATE_FORMAT_SLASHES_SHORT_DAY_MONTH_YEAR);
            const quoteDateIsToday = moment().isSame(updateDate, 'day');
            const formattedDate = quoteDateIsToday ? formatText('common-today') : DateHelper.buildFormattedDate(updateDate, DATE_FORMAT_DAY_MONTH_SHORT);

            const updateTime = entry.get('tradeTime') || '';
            const updateTimeElement = <span>{updateTime}</span>;

            return (
                <OKTableRow key={index}>
                    <OKTableCell
                        className="broker-todays-main-stocks__stocks-table-first-column"
                        maxWidth={BROKER_TODAYS_MAIN_STOCKS_MAX_COLUMN_WIDTH}
                        truncate={true}
                    >
                        <OKLink to={`/myprofile/broker/productFile/${entry.get('instrumentId')}/${entry.get('miccode')}`}>
                            {entry.get('instrument')}
                        </OKLink>
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                    >
                        <span className="broker-todays-main-stocks__right-value">
                            {formatAmount(entry.get('last'), getLanguage(), BROKER_TYPE_STOCKS_NEW_DECIMALS)}
                        </span>
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        className="broker-todays-main-stocks__stocks-table-column broker-todays-main-stocks__stocks-table-column--variation--featured-values"
                        width="190"
                    >
                        <StockExchangeIndexVariation
                            arrowCustomClassName="broker-todays-main-stocks__arrow-container"
                            variationPts={formatAmount(entry.get('netChangePrice'), getLanguage(), BROKER_TYPE_STOCKS_NEW_DECIMALS)}
                            variationPerc={formatAmount(entry.get('netChangePercentage'))}
                            upOrDown={entry.get('netChangePrice') > 0 ? 'up' : 'down'}
                        />
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        width="80"
                    >
                        <span className="broker-todays-main-stocks__right-value">
                            {formatAmount(entry.get('high'), getLanguage(), BROKER_TYPE_STOCKS_NEW_DECIMALS)}
                        </span>
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        width="70"
                    >
                        <span className="broker-todays-main-stocks__right-value">
                            {formatAmount(entry.get('low'), getLanguage(), BROKER_TYPE_STOCKS_NEW_DECIMALS)}
                        </span>
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        width="85"
                    >
                        <span className="broker-todays-main-stocks__right-value">
                            {formatAmount(entry.get('volume'), getLanguage(), 0)}
                        </span>
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        width="117"
                    >
                        <OKTooltip
                            content={formattedDate}
                            offset={[0, -15]}
                            target={updateTimeElement}
                            type="descriptive"
                        />
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        className="broker-todays-main-stocks__stocks-purchase"
                        width="9%"
                    >
                        <div className="broker-todays-main-stocks__buy-button">
                            <OKButton modifier="secondary" size="small" onClick={() => this.handleBuy(url)}>
                                <FormattedText value="broker-myInvestmentsBuyLink" />
                            </OKButton>
                        </div>
                    </OKTableCell>
                </OKTableRow>
            );
        });

        const todaysMainStocksTimeTooltip = <FormattedText value="broker-todaysMainStocksTimeTooltip" />;

        const iconInfo = (
            <OKTooltip
                content={todaysMainStocksTimeTooltip}
                offset={[0, -15]}
            />
        );

        const stocksTable = (
            <OKTable className="broker-todays-main-stocks__stocks-table">
                <thead>
                    <OKTableRow asHeader={true}>
                        <OKTableCell
                            asHeader={true}
                            className="broker-todays-main-stocks__stocks-table-first-column"
                        >
                            <FormattedText value="broker-todaysMainStocksStockNameColumnHeader" />
                        </OKTableCell>
                        <OKTableCell
                            asHeader={true}
                            alignment="right"
                        >
                            <FormattedText value="broker-todaysMainStocksLastValueColumnHeader" />
                        </OKTableCell>
                        <OKTableCell
                            alignment="right"
                            asHeader={true}
                            width="120"
                        >
                            <FormattedText value="broker-todaysMainStocksVariationColumnHeader" />
                        </OKTableCell>
                        <OKTableCell
                            alignment="right"
                            asHeader={true}
                            width="80"
                        >
                            <FormattedText value="broker-todaysMainStocksMaxValueColumnHeader" />
                        </OKTableCell>
                        <OKTableCell
                            alignment="right"
                            asHeader={true}
                            width="70"
                        >
                            <FormattedText value="broker-todaysMainStocksMinValueColumnHeader" />
                        </OKTableCell>
                        <OKTableCell
                            alignment="right"
                            asHeader={true}
                            width="85"
                        >
                            <FormattedText value="broker-todaysMainStocksVolumnColumnHeader" />
                        </OKTableCell>
                        <OKTableCell
                            alignment="right"
                            asHeader={true}
                            width="80"
                        >
                            <FormattedText className="broker-todays-main-stocks__stocks-table-time-header-text" value="broker-todaysMainStocksTimeColumnHeader" />
                            {iconInfo}
                        </OKTableCell>
                        <OKTableCell
                            alignment="right"
                            asHeader={true}
                            className="broker-todays-main-stocks__stocks-purchase"
                            width="9%"
                        >
                            <FormattedText value="broker-todaysMainStocksActionsColumnHeader" />
                        </OKTableCell>
                    </OKTableRow>
                </thead>
                <tbody>
                    {tableRows}
                </tbody>
            </OKTable>
        );
        const exchangeIndexesFetched = immBrokerExchangeIndexes.get('hasBeenFetched');
        const filtersBlock = hasFilters && (
            <BrokerMainStocksResultsListContentFilters
                exchangeIndexesFetched={exchangeIndexesFetched}
                filters={this.state.filters}
                activateTermFilter={this.activateTermFilter}
                clearFilters={this.clearFilters}
            />
        );

        const emptyState = this.buildEmptyState();

        const stocksResultsContent = (immStocksFinal.size !== 0) ? stocksTable : emptyState;

        const titleBlock = title && <p className="broker-main-stocks-results-list-box__results-sub-title">{title}</p>;

        return (
            <React.Fragment>
                <Prompt message={() => false} when={this.state.isBlockingRouteChange} />
                <div>
                    <BrokerClientWarningModal
                        nextLocation={this.state.nextLocation}
                        routerHookCallback={() => {
                            this.setState({ isBlockingRouteChange: false });
                        }}
                    />
                    {filtersBlock}
                    {titleBlock}
                    <div className="broker-todays-main-stocks__stocks-results-table-wrapper">
                        {stocksResultsContent}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

BrokerMainStocksResultsListContent.propTypes = {
    immStocks: PropTypes.object.isRequired,
    title: PropTypes.string,
    hasFilters: PropTypes.bool,
    immbrokerClientWarningModal: PropTypes.object,
    immBrokerExchangeIndexes: PropTypes.object,
    showClientWarningModal: PropTypes.func,
    selectedType: PropTypes.string,
    history: PropTypes.object.isRequired,
};

BrokerMainStocksResultsListContent.defaultProps = {
    title: '',
    hasFilters: false
}

module.exports.constructor = BrokerMainStocksResultsListContent;
module.exports.BrokerMainStocksResultsListContent = withRouter(connect(
    state => ({
        immbrokerClientWarningModal: state.brokerClientWarningModal,
        immBrokerExchangeIndexes: state.brokerExchangeIndexes
    }), {
    showClientWarningModal: BrokerClientWarningModalAction.showClientWarningModal
}
)(BrokerMainStocksResultsListContent));
